export const subdivision = [
'1 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'2 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'3 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'4 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'5 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'6 отдел СЧ по РОПД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',

'6 отдел ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',

'1 отдел УРППБД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'2 отдел УРППБД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'3 отдел УРППБД ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',

'1 отдел УРПНОН ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'2 отдел УРПНОН ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'3 отдел УРПНОН ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',
'4 отдел УРПНОН ГСУ ГУ МВД России по г. Санкт-Петербургу и Ленинградской области',

'СУ УМВД России по Адмиралтейскогму району г.Санкт-Петербурга',
'СУ УМВД России по Василеостровскому району г.Санкт-Петербурга',
'СУ УМВД России по Выборгскому району г.Санкт-Петербурга',
'СУ УМВД России по Калининскому району г.Санкт-Петербурга',
'СУ УМВД России по Кировскому району г.Санкт-Петербурга',
'СО ОМВД России по Колпинскому району г.Санкт-Петербурга',
'СУ УМВД России по Красногвардейскому району г.Санкт-Петербурга',
'СУ УМВД России по Красносельскому району г.Санкт-Петербурга',
'СО ОМВД России по Кронштадтскому району г.Санкт-Петербурга',
'СО ОМВД России по Курортному району г.Санкт-Петербурга',
'СУ УМВД России по Московскому району г.Санкт-Петербурга',
'СУ УМВД России по Невскому району г.Санкт-Петербурга',
'СУ УМВД России по Петроградскому району г.Санкт-Петербурга',
'СО ОМВД России по Петродворцовому району г.Санкт-Петербурга',
'СО ОМВД России по Пушкинскому району г.Санкт-Петербурга',
'СУ УМВД России по Приморскому району г.Санкт-Петербурга',
'СУ УМВД России по Фрунзенскому району г.Санкт-Петербурга',
'СУ УМВД России по Центральному району г.Санкт-Петербурга',

'СО ОМВД России по Бокситогорскому району Ленинградской области',
'СО ОМВД России по Волосовскому району Ленинградской области',
'СО ОМВД России по Волховскому району Ленинградской области',
'СУ УМВД России по Всеволожскому району Ленинградской области',
'СУ УМВД России по Выборгскому району Ленинградской области',
'СУ УМВД России по Гатчинскому району Ленинградской области',
'СО ОМВД России по Кингисепскому району Ленинградской области',
'СО ОМВД России по Киришскому району Ленинградской области',
'СО ОМВД России по Кировскому району Ленинградской области',
'СО ОМВД России по Лодейнопольскому району Ленинградской области',
'СО ОМВД России по Ломоносовскому району Ленинградской области',
'СО ОМВД России по Лужскому району Ленинградской области',
'СО ОМВД России по Подпорожскому району Ленинградской области',
'СО ОМВД России по Приозерскому району Ленинградской области',
'СО ОМВД России по Сланцевскому району Ленинградской области',
'СО ОМВД России по г. Сосновый бор Ленинградской области',
'СО ОМВД России по Тихвинскому району Ленинградской области',
'СО ОМВД России по Тосненскому району Ленинградской области',

'МО на ОВ и РО']

export const courts = [
'Василеостровский районный суд',
'Выборгский районный суд',
'Дзержинский районный суд',
'Зеленогорский районный суд',
'Калининский районный суд',
'Кировский районный суд',
'Колпинский районный суд',
'Красногвардейский районный суд',
'Красносельский районный суд',
'Кронштадтский районный суд',
'Куйбышевский районный суд',
'Ленинский районный суд',
'Московский районный суд города Санкт-Петербурга',
'Невский районный суд',
'Октябрьский районный суд',
'Петроградский районный суд',
'Петродворцовый районный суд',
'Приморский районный суд',
'Пушкинский районный суд',
'Сестрорецкий районный суд',
'Смольнинский районный суд',
'Фрунзенский районный суд',
'Санкт-Петербургский Городской суд',
'Ленинградский областной суд']

export const ivs = [
'УМВД России по Василеостровскому району г. Санкт-Петербурга',
'ОМВД России по Колпинскому району г. Санкт-Петербурга',
'УМВД России по Красногвардейскому району г. Санкт-Петербурга',
'УМВД России по Московскому району г. Санкт-Петербурга',
'УМВД России по Петроградскому району г. Санкт-Петербурга',
'ОМВД России по Петродворцовому району г. Санкт-Петербурга',
'УМВД России по Приморскому району г. Санкт-Петербурга',
'ОМВД России по Пушкинскому району г. Санкт-Петербурга',

'ОМВД России по Бокситогорскому району Ленинградской области',
'ОМВД России по Волосовскому району Ленинградской области',
'ОМВД России по Волховскому району Ленинградской области',
'УМВД России по Всеволожскому району Ленинградской области',
'УМВД России по Выборгскому району Ленинградской области',
'УМВД России по Гатчинскому району Ленинградской области',
'ОМВД России по Кингисеппскому району Ленинградской области',
'ОМВД России по Киришскому району Ленинградской области',
'ОМВД России по Кировскому району Ленинградской области',
'ОМВД России по Лодейнопольскому району Ленинградской области',
'ОМВД России по Ломоносовскому району Ленинградской области',
'ОМВД России по Лужскому району Ленинградской области',
'ОМВД России по Подпорожскому району Ленинградской области',
'ОМВД России по Приозерскому району Ленинградской области',
'ОМВД России по Сланцевскому району Ленинградской области',
'ОМВД России по г. Сосновый Бор Ленинградской области',
'ОМВД России по Тихвинскому району Ленинградской области',
'ОМВД России по Тосненскому району Ленинградской области']

export const sizoListTEST = [
{title:'СИЗО-1', email:'testsizop@fgspmail.ru', address:'г.Санкт-Петербург, гор. Колпино, Колпинская ул., д.9'}, 
{title:'СИЗО-5', email:'testsizop5@fgspmail.ru', address:'г.Санкт-Петербург, Арсенальная ул., д.11, 195009'}, 
{title:'СИЗО-6', email:'testsizop6@fgspmail.ru', address:'г.Санкт-Петербург, ул. Заречная, д.22, 190000'}]

export const sizoList = [
{title:'СИЗО-1', email:'krestyosu@fgspmail.ru', address:'г.Санкт-Петербург, гор. Колпино, Колпинская ул., д.9'}, 
{title:'СИЗО-5', email:'krestyosu5@fgspmail.ru', address:'г.Санкт-Петербург, Арсенальная ул., д.11, 195009'}, 
{title:'СИЗО-6', email:'krestyosu6@fgspmail.ru', address:'г.Санкт-Петербург, ул. Заречная, д.22, 190000'}]

export const sizoListTMP = [
{title:'СИЗО-1', email:'krestyosu@fgspmail.ru', address:'г.Санкт-Петербург, гор. Колпино, Колпинская ул., д.9'}, 
{title:'СИЗО-2', email:'krestyosu2@fgspmail.ru', address:'Ленинградская область, г. Тихвин, ул. Красноармейская, д.13, 187550'}, 
{title:'СИЗО-3', email:'krestyosu3@fgspmail.ru', address:'Санкт-Петербург и ЛО, г. Санкт-Петербург, ул. Шпалерная д. 25, 191123'}, 
{title:'СИЗО-5', email:'krestyosu5@fgspmail.ru', address:'г.Санкт-Петербург, Арсенальная ул., д.11, 195009'}, 
{title:'СИЗО-6', email:'krestyosu6@fgspmail.ru', address:'г.Санкт-Петербург, ул. Заречная, д.22, 190000'}]
